import { ArrowRight } from 'lucide-react';
import { cn } from '@/utils/cn';
import { DIFF_BG, DIFF_SIGN, DIFF_SIGN_COLOR } from './constants';
import type { DiffItemRow } from './types';

interface ItemsDiffProps {
  rows: DiffItemRow[];
  onlyChanges: boolean;
}

export const ItemsDiff = ({ rows, onlyChanges }: ItemsDiffProps) => {
  const numbered = rows.map((row, i) => ({ row, n: i + 1 }));
  const visible = onlyChanges ? numbered.filter(({ row }) => row.status !== 'unchanged') : numbered;
  return (
    <div className="divide-y divide-neutral-100">
      {visible.map(({ row, n }) => (
        <div
          key={row.id}
          data-diff-change={row.status !== 'unchanged' || undefined}
          className={cn('flex gap-3 px-3 py-2', DIFF_BG[row.status])}
        >
          <span
            className={cn(
              'w-4 shrink-0 font-mono text-[12px] text-center leading-5',
              DIFF_SIGN_COLOR[row.status]
            )}
          >
            {DIFF_SIGN[row.status] || n}
          </span>
          <div className="min-w-0 flex-1">
            <div className="text-xs font-medium text-neutral-600">
              {
                {
                  added: 'Přidáno',
                  removed: 'Odebráno',
                  changed: 'Změněno',
                  unchanged: 'Beze změn',
                }[row.status]
              }
            </div>
            <div
              className={cn(
                'text-[13px] leading-5',
                row.status === 'removed'
                  ? 'text-neutral-500 line-through'
                  : 'text-neutral-900 font-medium'
              )}
            >
              {row.label}
            </div>
            {row.status === 'changed' ? (
              <div className="mt-1 grid grid-cols-[1fr_auto_1fr] items-center gap-2">
                <span className="font-mono text-[11.5px] text-red-700 bg-red-100/70 rounded px-1.5 py-0.5 line-through decoration-red-400">
                  <span className="block font-sans">Původně</span>
                  {row.old_detail ?? '—'}
                </span>
                <ArrowRight size={11} className="text-neutral-400" />
                <span className="font-mono text-[11.5px] text-emerald-800 bg-emerald-100/70 rounded px-1.5 py-0.5">
                  <span className="block font-sans">Nově</span>
                  {row.new_detail ?? '—'}
                </span>
              </div>
            ) : (
              <div
                className={cn(
                  'mt-0.5 font-mono text-[11.5px]',
                  row.status === 'removed'
                    ? 'text-red-600'
                    : row.status === 'added'
                    ? 'text-emerald-700'
                    : 'text-neutral-500'
                )}
              >
                {row.new_detail ?? row.old_detail}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
